import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface User {
  id: string;
  name: string;
}

export interface LeaveBalances {
  annualLeave: string;
  sickLeave: string;
  pressingNecessity: string;
  compassionate: string;
  bereavement: string;
  juryDuty: string;
  election: string;
  bandBusiness: string;
  governance: string;
  education: string;
  professionalDevelopment: string;
  culturalSpiritual: string;
  leaveWithoutPay: string;
}

export interface UserLeaveBalanceData {
  user: User;
  year: number;
  lateLeaveDaysDeducted: number;
  balances: LeaveBalances;
}

export interface UserLeaveBalanceResponse {
  success: boolean;
  message: string;
  data: UserLeaveBalanceData;
}

const fetchUserLeaveBalance = async (
  userId: string
): Promise<UserLeaveBalanceResponse> => {
  const { data } = await customAxios.get<UserLeaveBalanceResponse>(
    `/leaves/user-leave-balance/${userId}`
  );
  return data;
};

export const useGetUserLeaveBalance = (userId: string) =>
  useQuery<UserLeaveBalanceResponse, AxiosError>(
    ["userLeaveBalance", userId],
    () => fetchUserLeaveBalance(userId),
    {
      enabled: !!userId,
      onError: (error) =>
        showNotification({
          title: "Error Loading Leave Balance",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load leave balance data",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
